import {
  EMAIL_INVITE_FAIL,
  EMAIL_INVITE_REQUEST,
  EMAIL_INVITE_RESET,
  EMAIL_INVITE_SUCCESS,
  EMAIL_PASSWORD_FAIL,
  EMAIL_PASSWORD_REQUEST,
  EMAIL_PASSWORD_RESET,
  EMAIL_PASSWORD_SUCCESS,
  EMAIL_PROJECT_NOTIFICATION_FAIL,
  EMAIL_PROJECT_NOTIFICATION_REQUEST,
  EMAIL_PROJECT_NOTIFICATION_RESET,
  EMAIL_PROJECT_NOTIFICATION_SUCCESS,
  EMAIL_SUPPORT_FAIL,
  EMAIL_SUPPORT_REQUEST,
  EMAIL_SUPPORT_RESET,
  EMAIL_SUPPORT_SUCCESS,
  EMAIL_VALIDATION_FAIL,
  EMAIL_VALIDATION_REQUEST,
  EMAIL_VALIDATION_RESET,
  EMAIL_VALIDATION_SUCCESS,
} from '../constants/emailConstants'

export const emailValidationReducer = (state = {}, action) => {
  switch (action.type) {
    case EMAIL_VALIDATION_REQUEST:
      return { loading: true }
    case EMAIL_VALIDATION_SUCCESS:
      return { loading: false, success: true }
    case EMAIL_VALIDATION_FAIL:
      return { loading: false, error: action.payload }
    case EMAIL_VALIDATION_RESET:
      return {}
    default:
      return state
  }
}

export const emailPasswordReducer = (state = {}, action) => {
  switch (action.type) {
    case EMAIL_PASSWORD_REQUEST:
      return { loading: true }
    case EMAIL_PASSWORD_SUCCESS:
      return { loading: false, success: true }
    case EMAIL_PASSWORD_FAIL:
      return { loading: false, error: action.payload }
    case EMAIL_PASSWORD_RESET:
      return {}
    default:
      return state
  }
}

export const emailInviteReducer = (state = {}, action) => {
  switch (action.type) {
    case EMAIL_INVITE_REQUEST:
      return { loading: true }
    case EMAIL_INVITE_SUCCESS:
      return { loading: false, success: true }
    case EMAIL_INVITE_FAIL:
      return { loading: false, error: action.payload }
    case EMAIL_INVITE_RESET:
      return {}
    default:
      return state
  }
}

export const emailProjectNotificationReducer = (state = {}, action) => {
  switch (action.type) {
    case EMAIL_PROJECT_NOTIFICATION_REQUEST:
      return { ...state, loading: true, success: false }
    case EMAIL_PROJECT_NOTIFICATION_SUCCESS:
      return { ...state, loading: false, success: true, user: action.payload }
    case EMAIL_PROJECT_NOTIFICATION_FAIL:
      return { ...state, loading: false, success: false, error: action.payload }
    case EMAIL_PROJECT_NOTIFICATION_RESET:
      return { ...state, loading: false, success: false }
    default:
      return state
  }
}

export const emailSupportReducer = (state = {}, action) => {
  switch (action.type) {
    case EMAIL_SUPPORT_REQUEST:
      return { ...state, loading: true, success: false }
    case EMAIL_SUPPORT_SUCCESS:
      return { ...state, loading: false, success: true }
    case EMAIL_SUPPORT_FAIL:
      return { ...state, loading: false, success: false, error: action.payload }
    case EMAIL_SUPPORT_RESET:
      return { ...state, loading: false, success: false, error: '' }
    default:
      return state
  }
}
